import {handleActions} from 'redux-actions'
import {LOGGED_IN_USER_UPDATE} from './actionTypes'

const createLoggedInUserReducer = ({
    LOGGED_IN_USER = null
}) => {
    const initialState = {
        ...LOGGED_IN_USER
    }

    return handleActions({
        [LOGGED_IN_USER_UPDATE]: (state, {payload: userInfo}) => ({
            ...state,
            ...userInfo
        }),
    }, initialState)
}

export default createLoggedInUserReducer



// WEBPACK FOOTER //
// ./web/js/loggedInUser/reducer.js